<template>
  <v-list-group>
    <template v-slot:activator>
      <v-list-item-content
        style="display: flex; flex-direction: row; height: 50px; padding: 0px"
        class="p-0"
      >
        <v-list-item-title style="max-width: 120px">
          {{ selectLabel }}
        </v-list-item-title>
      </v-list-item-content>
      <!-- <v-checkbox class="ml-2" v-model="selectAll"></v-checkbox> -->
    </template>

    <v-list-item
      v-for="(item, i) in options"
      :key="i"
      link
      style="display: flex; justify-content: flex-start"
    >
      <v-checkbox :value="item" v-model="setOptions" @change="select(item)">
      </v-checkbox>
      <v-list-item-title v-text="item"></v-list-item-title>
    </v-list-item>
  </v-list-group>
</template>

<script>
export default {
  props: {
    options: {
      type: Array,
    },
    selectLabel: {
      type: String,
    },
    selectedOptions: {
      type: Array
    }
  },
  data() {
    return {
      selectValue: this.options,
      setOptions: this.selectedOptions,
    };
  },
  methods: {
    isSelected: function (value) {
      let index = -1;
      Object.keys(this.selectValue).forEach((key) => {
        if (this.selectValue[key] === value) {
          index = parseInt(key, 10);
        }
      });

      return index > -1;
    },
    select: function (value) {
    
      let shouldAdd = true;
      let nuevo = [];
      Object.keys(this.selectValue).forEach((key) => {
        if (this.selectValue[key] === value) {
          shouldAdd = false;
        } else {
          nuevo.push(this.selectValue[key]);
        }
      });

      if (shouldAdd) {
        nuevo.push(value);
      }

      this.selectValue = nuevo;
      this.$emit("onChange", this.selectValue);
    },
  },
  computed: {
 
  },
};
</script>

<style>
</style>